import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const paymentGatewaysApiSlice = createApi({
  reducerPath: 'paymentGatewaysApiSlice',
  tagTypes: ['PaymentGateways', 'OnboardingLinks'],
  baseQuery,
  serializeQueryArgs,
  endpoints: (builder) => ({
    getCompaniesPaymentGateways: builder.query({
      query: ({ apiManager, ...params }) => apiManager.get(params),
      providesTags: ['PaymentGateways'],
    }),
    updateCompanyPaymentGateway: builder.mutation({
      query: ({ apiManager, companyId, payment_gateway }) =>
        apiManager.updatePaymentGateway(companyId, { payment_gateway }),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['PaymentGateways'];
      },
    }),
    getPaymentGatewayStats: builder.query({
      query: ({ apiManager, ...params }) => apiManager.getStats(params),
    }),
    getCompanyOnboardingLinks: builder.query({
      query: ({ apiManager, companyId }) => apiManager.getOnboardingLinks(companyId),
      providesTags: (_, __, { companyId }) => [{ type: 'OnboardingLinks', id: companyId }],
    }),
    createCompanyOnboardingLink: builder.mutation({
      query: ({ apiManager, companyId, payment_gateway }) =>
        apiManager.createOnboardingLink(companyId, { payment_gateway }),
      invalidatesTags: (_, error, { companyId }) => {
        if (error) {
          return [];
        }

        return [{ type: 'OnboardingLinks', id: companyId }];
      },
    }),
  }),
});

export const {
  useGetCompaniesPaymentGatewaysQuery,
  useUpdateCompanyPaymentGatewayMutation,
  useGetPaymentGatewayStatsQuery,
  useGetCompanyOnboardingLinksQuery,
  useCreateCompanyOnboardingLinkMutation,
} = paymentGatewaysApiSlice;
